import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../api";

export const sellMyCarApi = createApi({
  reducerPath: "sellMyCarApi", // Unique key in Redux store
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  endpoints: (builder) => ({
    getVehicleInfo: builder.query({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "GET",
      })
    }),
    submitCarForm: builder.query({
      query: ({ formData, endpoint }) => ({
        url: endpoint,
        method: "POST",
        body: formData,
      }),
    }),
    relistCar: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/seller/relistingeditfunctionality/${Vehicle_Id}/Relist`,
          method: "GET"
        }
      }
    })
  }),
});

export const { 
  useSubmitCarFormQuery,
  useGetVehicleInfoQuery
} = sellMyCarApi;

export const {
  useLazyGetVehicleInfoQuery,
  useLazySubmitCarFormQuery,
  useLazyRelistCarQuery
} = sellMyCarApi;

